export default "__VITE_ASSET__855bc52e__"